import React from "react";
import { useCompleteTasks } from "shared/hooks/api/use-complete-tasks";
import { faCheck, faClose } from "@fortawesome/free-solid-svg-icons";
import { Chip } from "../../../chip/chip";
import Modal from "../../../modal";
import { Controller, useForm } from "react-hook-form";
import { Textarea } from "../../../form-inputs/inputs";
import { useModal } from "../../../../shared/hooks/use-modal";
import { SECTION_MAP } from "../../lib/constants";
import { sendNote } from "../../../notes/lib/data";
import * as notify from "shared/notify";

export const StateController = ({ selectedProducts, onTaskCompleteRefresh, isVOComplete, isVOReject, isPhotography, sourcePage, onUnselectRows }) => {
    const { mutateAsync: completeTasks } = useCompleteTasks();
    const { open: openRejectModal, onOpen: handleOpenRejectModal, onClose: handleCloseRejectModal } = useModal();
    const { handleSubmit, control } = useForm();

    const handleCompleteTask = (rejected = false) => {
        notify.success(
            ` ${
                rejected
                    ? "Task(s) have been rejected"
                    : "The items have been queued. Please pay attention to the Teams channel for possible failures"
            }`
        );
        onTaskCompleteRefresh();
    };

    const handleApproveTasks = async () => {
        if (isVOComplete) {
            return;
        }

        if (!selectedProducts.length) {
            notify.warning(`You must select at least 1 product`);

            return;
        }

        const accept = await notify.confirm(
            `The selected ${selectedProducts.length} UPC(s) will be completed in their current state and will proceed in the workflow. Do you want to continue?`
        );

        if (!accept) {
            return;
        }

        onUnselectRows();

        try {
            await completeTasks({ selectedProducts, sourcePage });
            handleCompleteTask();
        } catch (err) {
            console.log(err);
        }
    };

    const handleRejectTasks = async () => {
        if (isVOReject) {
            return;
        }

        if (!selectedProducts.length) {
            notify.warning(`You must select at least 1 product`);

            return;
        }

        const accept = await notify.confirm(
            `The ${selectedProducts.length} selected UPC(s) will not go to Bright River without a reject reason. Are you sure you want to reject?`
        );

        if (!accept) {
            return;
        }

        handleOpenRejectModal();
    };

    const onSubmit = async (formValues) => {
        const rejectComment = await sendNote(
            {
                items: selectedProducts.map((product) => {
                    const [shortTaskType] = product.taskType.split(".");
                    const noteTaskType = SECTION_MAP[shortTaskType].noteKey;

                    return {
                        noteText: formValues[product.context.upc],
                        noteType: "Product",
                        shipmentKey: product.context.shipmentKey,
                        shipmentProductKey: product.context.shipmentProductKey,
                        taskType: noteTaskType,
                    };
                }),
            },
            sourcePage
        );

        if (!rejectComment) {
            notify.error("Task comment did not save!");

            return;
        }

        completeTasks(
            { selectedProducts, reject: true, sourcePage },
            {
                onSuccess: () => {
                    handleCompleteTask(true);
                    handleCloseRejectModal();
                },
            }
        );
    };

    return (
        <>
            <div className="flex border">
                <Chip
                    label={isPhotography ? "Complete Task(s)" : "Accept Task(s)"}
                    icon={faCheck}
                    onClick={handleApproveTasks}
                    disabled={isVOComplete}
                />
                {!isPhotography && (
                    <Chip
                        label="Reject Task(s)"
                        icon={faClose}
                        onClick={handleRejectTasks}
                        disabled={isVOReject}
                    />
                )}
            </div>
            {openRejectModal && (
                <Modal
                    show={openRejectModal}
                    onClose={handleCloseRejectModal}
                >
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <h2 className="flex justify-content-center">Reason for reject:</h2>
                        <div className="form-fields">
                            {selectedProducts.map((product) => {
                                return (
                                    <Controller
                                        key={product.context.upc}
                                        control={control}
                                        name={product.context.upc}
                                        render={({ field }) => {
                                            return (
                                                <Textarea
                                                    required
                                                    label={`UPC: ${product.context.upc}`}
                                                    {...field}
                                                />
                                            );
                                        }}
                                    />
                                );
                            })}
                        </div>

                        <div className="button-group justify-content-center m-t-16 p-l-12 p-r-12">
                            <button
                                type="button"
                                className="button "
                                onClick={handleCloseRejectModal}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="button -primary"
                            >
                                Reject
                            </button>
                        </div>
                    </form>
                </Modal>
            )}
        </>
    );
};
